module.exports = __webpack_public_path__ + "img/QRcode.49ba572.jpg";